module.exports = __webpack_public_path__ + "img/1.bae013a6.png";